import classNames from "classnames";
import { useRelatorioStore } from "pages/relatorios/store";
import { useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import styles from "./style.module.scss";

type ImpressaoContainerProps = {
	children: React.ReactNode;
	title?: string;
	className?: string;
	style?: React.CSSProperties;
	pageStylePrint?: string;
};

export function ImpressaoContainer(props: ImpressaoContainerProps) {
	const { children, title = "", className, style } = props;

	const isImpressaoRequisitado = useRelatorioStore((s) => s.isImpressaoRequisitado);

	const printRef = useRef(null);

	const handlePrint = useReactToPrint({
		contentRef: printRef,
		documentTitle: title,
		bodyClass: styles.bodyStyle,
		pageStyle: props.pageStylePrint,
		onAfterPrint: () => {
			useRelatorioStore.setState({ isImpressaoRequisitado: false });
		},
	});

	useEffect(() => {
		if (!isImpressaoRequisitado) {
			return;
		}

		const timer = window.setTimeout(() => {
			handlePrint();
		}, 150);

		return () => window.clearTimeout(timer);
	}, [isImpressaoRequisitado, handlePrint]);

	return (
		<div ref={printRef} className={classNames(styles["relatorio-container"], className)} style={style}>
			{children}
		</div>
	);
}
